import { useAppSelector } from "@/hooks/useAppSelector";
import { FinalData } from "@/types/onboarding";
import { createContext, useContext, useState, ReactNode } from "react";



// Define the type for the context
interface FormContextType {
  finalData: FinalData;
  setFinalData: (data: Partial<FinalData>) => void;
}

// Create context with default values
const FormContext = createContext<FormContextType | undefined>(undefined);

// Context provider component
export const FormProvider = ({ children }: { children: ReactNode }) => {
    const {phoneNumber} = useAppSelector((state)=>state.auth);
  const [finalData, setFinalDataState] = useState<FinalData>({
    Email: null,
    PhoneNumber: phoneNumber || null,
    ReceiveWhatsApp: false,
    FirstName: null,
    LastName: null,
    Gender: null,
    DOB: null,
    USER_IMAGE: null,
    pin_code: null,
    location: null,
    district: null,
    state_id: null,
    address_line_1: null,
    address_line_2: null,
    save_address: "Dealership",
    pan_card: null,
    Have_GSTIN: "yes",
    business_name: null,
    applicable: "",
    aadhar: null,
    GST: null
  });

  // Update form data without losing previous values
  const setFinalData = (data: Partial<FinalData>) => {
    setFinalDataState((prev) => ({ ...prev, ...data }));
  };

  return <FormContext.Provider value={{ finalData, setFinalData }}>{children}</FormContext.Provider>;
};

// Custom hook to use the context
export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
